import { DefaultService } from '@/services/DefaultService';

export default class TipoCadastroTalhaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(tipocadastrotalhao) {
        return this._http.post(`${this._env}/agro/fieldregistrationtype`, tipocadastrotalhao, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/fieldregistrationtype/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(tipocadastro) {
        return this._http.post(`${this._env}/agro/fieldregistrationtype/updatesituation`, tipocadastro, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/fieldregistrationtype.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(...params) {
        return this._http.get(encodeURI(`${this._env}/agro/fieldregistrationtype/getcombo.json?param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}